import React from 'react';
import { connect } from 'react-redux';
import { fetchNewsModel } from './NewsBlock.action';
import NewsBlock from './NewsBlock';

class NewsBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <NewsBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchNewsModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.NewsReducer.result
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(NewsBlockContainer);